export default {"src":"/_next/static/media/PPI.765b9c94.svg","height":2994,"width":1313,"blurWidth":0,"blurHeight":0};